import config from '../../config';
import Location from '../../ports-frontend/Location';
import { pathJoin } from '../../logic/main/utils';

export async function getCanonicalUrl(canonical?: {
  origin: 'cross' | 'same';
  url: string;
}) {
  const appUrl = config.urls.app && new URL(config.urls.app).origin;

  const removeEnGbPart = (path?: string) =>
    path ? path.replace('en-gb', '').replace(/\/\//g, '/') : '';

  if (!canonical) {
    const location = await Location.get();
    return pathJoin([appUrl, removeEnGbPart(location.pathname)]);
  }
  if (canonical.origin === 'cross') return canonical.url;

  return pathJoin([
    appUrl,
    removeEnGbPart(config.base_path),
    removeEnGbPart(canonical.url),
  ]);
}
